// extracted by mini-css-extract-plugin
export default {"bottomPanel":"BottomPanel_bottomPanel__vfbLa","bottomPanelWrap":"BottomPanel_bottomPanelWrap__67dmZ","panelColumn":"BottomPanel_panelColumn__A3eQc"};